import {
  anUpdateTaxiiThreatIntelSource,
  mockUpdateTaxiiThreatIntelSourceOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockUpdateTaxiiThreatIntelSourceOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          updateTaxiiThreatIntelSource: anUpdateTaxiiThreatIntelSource(),
        },
      });
    }
  ),
];
